import { I18n } from "i18n-js";
import React from "react";
const { locale, translations } = window.I18nJs || { locale: 'en', translations: {} };

const i18n = new I18n(translations);
i18n.locale = locale;

/**
 * Custom translation function that supports React components as placeholders.
 * @param {string} key - The translation key.
 * @param {object} options - The options object containing placeholders.
 * @returns {React.Element} - The translated text with React components.
 */
i18n.tWithReact = (key, options = {}) => {
  let reactComponents = {};

  // Iterate over the options to find React components
  Object.keys(options).forEach(key => {
    const obj = options[key];

    if (React.isValidElement(obj)) {
      reactComponents[key] = obj;
      options[key] = `%{${key}}`; // Replace React component with placeholder
    }
  });

  // Get the translated text with placeholders
  const translatedText = i18n.t(key, options);
  return replacePlaceholders(translatedText, reactComponents);
};

/**
 * Replace placeholders in the translated text with React components.
 * @param {string} text - The translated text containing placeholders.
 * @param {object} replacements - The object containing React components.
 * @returns {Array} - An array of strings and React elements.
 */
const replacePlaceholders = (text, replacements) => {
  // Split the translated text by placeholders (e.g., %{placeholder})
  const parts = text.split(/(%\{[^}]+\})/g);

  // Map over the parts and replace placeholders with React components
  return parts.map((part, index) => {
    // Check if the part matches a placeholder pattern
    const match = part.match(/%\{(.+)\}/);

    // If a match is found and a corresponding React component exists, return the component
    if (match && replacements[match[1]]) {
      return <React.Fragment key={index}>{replacements[match[1]]}</React.Fragment>;
    }

    // Otherwise, return the part as is (string)
    return part;
  });
};

export default i18n;
